import { Fragment } from "react";
import {
  Grid,
  IconButton,
  InputAdornment,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { useAlert, useAxios } from "../../hooks";
import { Label, TextField } from "../../components";
import { useDispatch } from "react-redux";

export default function FormDisplay({
  otpSent,
  setOtpSent,
  isOtpLogin,
  formikProps,
  setIsOtpLogin,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { alert } = useAlert();

  const toggleLoginMethod = () => {
    setIsOtpLogin((prev) => !prev);
    formikProps.resetForm();
    setOtpSent(false);
  };

  const handleSendOtp = () => {
    if (!formikProps.values.mobile) return;

    axios({
      url: `event/booking/send-otp?&visitor=false&mobile_no=91${formikProps.values.mobile}`,
      method: "POST",
    })
      .then((response) => {
        if (response.status) {
          setOtpSent(true);
          dispatch(
            alert({
              type: "success",
              message:
                response.message.displayMessage || "OTP sent successfully!",
            })
          );
        }
      })
      .catch((error) => {
        console.error("OTP send error", error);
      });
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <img
          src="https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/mpsedc/digipass/events1765166449543_1765166452253_goenka.jpg"
          alt="Sign In"
          style={{
            width: "100%",
            maxHeight: "200px",
            objectFit: "contain",
            borderRadius: "5px",
          }}
        />
      </Grid>
      <Grid item xs={12} mt={2} mb={2}>
        <Typography variant="h5" fontWeight={600} align="center">
          {isOtpLogin ? "Gate Keeper Login With OTP" : "Gate Keeper Login"}
        </Typography>
      </Grid>

      <Box
        sx={{
          mt: 2,
          boxShadow: "3px 3px 5px 1px #2a2a2a5c",
          padding: 4,
          borderRadius: 2,
        }}
        container
        spacing={2}
      >
        {isOtpLogin ? (
          <>
            <Grid item xs={12}>
              <Label required title="Mobile Number" formikProps={formikProps} />
              <TextField
                required
                name="mobile"
                placeholder="Enter mobile number"
                formikProps={formikProps}
              />
            </Grid>

            {otpSent && (
              <Grid item xs={12}>
                <Label required title="OTP" formikProps={formikProps} />
                <TextField
                  required
                  name="otp"
                  placeholder="Enter OTP"
                  formikProps={formikProps}
                />
              </Grid>
            )}
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <Label
                required
                title="Email / User Name"
                formikProps={formikProps}
              />
              <TextField
                required
                name="email"
                placeholder="john@sample.com"
                formikProps={formikProps}
              />
            </Grid>

            <Grid item xs={12}>
              <Label required title="Password" formikProps={formikProps} />
              <TextField
                required
                type="password"
                name="password"
                placeholder="Enter your password"
                formikProps={formikProps}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <VisibilityIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12} mt={3}>
          {isOtpLogin ? (
            !otpSent ? (
              <LoadingButton
                type="button"
                variant="contained"
                fullWidth
                onClick={handleSendOtp}
                loading={formikProps.isSubmitting}
              >
                Send OTP
              </LoadingButton>
            ) : (
              <LoadingButton
                type="submit"
                variant="contained"
                fullWidth
                onClick={formikProps.handleSubmit}
                loading={formikProps.isSubmitting}
                disabled={!formikProps.dirty || !formikProps.isValid}
              >
                Verify OTP
              </LoadingButton>
            )
          ) : (
            <LoadingButton
              type="submit"
              variant="contained"
              fullWidth
              loading={formikProps.isSubmitting}
              disabled={!formikProps.dirty || !formikProps.isValid}
            >
              Login
            </LoadingButton>
          )}
        </Grid>

        <Grid item xs={12} mt={3}>
          <Button variant="outlined" fullWidth onClick={toggleLoginMethod}>
            {isOtpLogin ? "Login with Email & Password" : "Login with OTP"}
          </Button>
        </Grid>
      </Box>
    </Fragment>
  );
}
